import React, { Component } from 'react'
import Chart from '../../components/Chart';
import format from '../../../shared/format';

export default class AdaptChart extends Component {
    
    shouldComponentUpdate(nextProps) {
        if (
            nextProps.data !== this.props.data ||
            nextProps.showLegend !== this.props.showLegend
        ) {
            return true;
        }
        return false;
    }

    isObject(obj) {
        return Object.prototype.toString.call(obj) === '[object Object]';
    }

    render() {
        const { chartTypes, dataType, showLegend, data, unit, filename, onExport } = this.props;
        const { monthList = [] } = data;
        const categories = monthList.map(i => format('month', i.year, i.month));
        const series = [];
        const yAxis = [];
        (chartTypes || []).forEach((type, index) => {
            const obj = data[`${type}sData`] || {};
            Object.entries(this.isObject(obj) ? obj : {}).forEach(([key, value]) => {
                const result = { name: key };
                if (type === 'column') {
                    result.type = 'column';
                } else if (type === 'line') {
                    result.type = 'spline';
                }
                result.data = (value || []).map(i => i[dataType]);
                if (index !== 0) {
                    result.yAxis = 1;
                }
                series.push(result);
            });
    
            const params = { title: { text: '' } };
            if (unit && index === 0) {
                params.title = {
                    enabled: true,
                    align: 'high',
                    offset: -20,
                    text: `单位：${unit}`,
                    rotation: 0,
                    y: -12
                };
            }
            if (index !== 0) {
                params.opposite = true;
            }
            yAxis.push(params);
        });
    
        return (
            <div style={{ position: 'relative' }}>
                <Chart
                    filename={filename}
                    xAxis={{categories}}
                    yAxis={yAxis}
                    legend={{
                        enabled: showLegend
                    }}
                    series={series}
                    onExport={onExport}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/homePage/projectIndicatorAnalysis/components/AdaptChart.js